import { Item } from 'typings'

export const enum GIFT_APPLICATION {
  PER_ITEM = 'perItem',
  PER_CART = 'perCart',
}

export enum GiftKeys {
  items = 'items',
  application = 'application',
  maxQuantity = 'maxQuantity',
}

export type Gift<T> = {
  type: T
  [GiftKeys.items]: Item[]
  [GiftKeys.application]: GIFT_APPLICATION
  [GiftKeys.maxQuantity]: number
}
